import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const switchRecipeDefaultVariants = {
  "size": "md",
  "labelPosition": "end"
}
const switchRecipeCompoundVariants = []

const switchRecipeSlotNames = [
  [
    "root",
    "switch__root"
  ],
  [
    "track",
    "switch__track"
  ],
  [
    "thumb",
    "switch__thumb"
  ],
  [
    "label",
    "switch__label"
  ]
]
const switchRecipeSlotFns = /* @__PURE__ */ switchRecipeSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, switchRecipeDefaultVariants, getSlotCompoundVariant(switchRecipeCompoundVariants, slotName))])

const switchRecipeFn = memo((props = {}) => {
  return Object.fromEntries(switchRecipeSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const switchRecipeVariantKeys = [
  "labelPosition",
  "size"
]
const getVariantProps = (variants) => ({ ...switchRecipeDefaultVariants, ...compact(variants) })

export const switchRecipe = /* @__PURE__ */ Object.assign(switchRecipeFn, {
  __recipe__: false,
  __name__: 'switchRecipe',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: switchRecipeVariantKeys,
  variantMap: {
  "labelPosition": [
    "end",
    "start"
  ],
  "size": [
    "sm",
    "md",
    "lg"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, switchRecipeVariantKeys)
  },
  getVariantProps
})